import axiosAPI from '@/api/axios'

export default {
  async fetchDomains() {
    return await axiosAPI.get('/api/sms-center/instant/domains')
  },

  async fetchSetting(domainId) {
    return await axiosAPI.get(`/api/sms-center/instant/settings/${domainId}`)
  },

  async updateSetting(domainId, payload) {
    return await axiosAPI.post(
      `/api/sms-center/instant/settings/${domainId}`,
      payload,
    )
  },

  async fetchSends(data) {
    return await axiosAPI.get('/api/sms-center/instant/sends', { params: data })
  },

  async fetchSend(id) {
    return await axiosAPI.get(`/api/sms-center/instant/sends/${id}`)
  },

  async resendSend(id) {
    return await axiosAPI.post(`/api/sms-center/instant/sends/${id}/resend`)
  },
}
